import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMarker = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3587 6.64125C15.0658 6.34836 14.5909 6.34836 14.298 6.64125L10.0554 10.8839C9.76251 11.1768 9.76251 11.6517 10.0554 11.9446C10.3483 12.2374 10.8232 12.2374 11.1161 11.9446L15.3587 7.70191C15.6516 7.40902 15.6516 6.93415 15.3587 6.64125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.9549 4.16635C20.8336 5.04503 20.8336 6.46965 19.9549 7.34833L10.1733 17.13C9.75252 17.5507 9.20667 17.8236 8.61763 17.9078L6.30775 18.2378C4.82282 18.4499 3.55003 17.1771 3.76216 15.6922L4.09215 13.3823C4.17629 12.7933 4.44922 12.2474 4.86996 11.8267L14.6516 2.04503C15.5303 1.16635 16.9549 1.16635 17.8336 2.04503L19.9549 4.16635ZM18.8942 6.28767C19.1871 5.99477 19.1871 5.5199 18.8942 5.22701L16.7729 3.10569C16.48 2.81279 16.0052 2.81279 15.7123 3.10569L6.6966 12.1214L9.87858 15.3033L18.8942 6.28767ZM8.76735 16.3134L5.68651 13.2326C5.63224 13.3462 5.59511 13.4682 5.57707 13.5944L5.24709 15.9043C5.17638 16.3993 5.60064 16.8236 6.09561 16.7528L8.4055 16.4229C8.53178 16.4048 8.6537 16.3677 8.76735 16.3134Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.53039 19.5303C4.82328 19.2374 4.82328 18.7626 4.53039 18.4697C4.2375 18.1768 3.76262 18.1768 3.46973 18.4697L2.17684 19.7626C1.0744 20.865 1.85519 22.75 3.41427 22.75H21.0001C21.4143 22.75 21.7501 22.4142 21.7501 22C21.7501 21.5858 21.4143 21.25 21.0001 21.25H3.41427C3.19155 21.25 3.08001 20.9807 3.2375 20.8232L4.53039 19.5303Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconMarker as ReactComponent };
